let msgServer;
import QrcodeVue from 'qrcode.vue'
import {DoccliService} from '../../../../providers/DoccliService.js';
const doccliService = new DoccliService();
import {AppService} from '../../../../providers/AppService.js';
const appService = new AppService();
export default {
    name: "QrcodeScan",
    data () {
      return {
        tabs: null,
        text: 'chargement en cours...',
        sdkwebScan:"",
        qrcodeSize: 200,
        showWait: true,
        message:'',

      }
  },components: {
    QrcodeVue,
  },
  mounted: function () {
   
    this.getQrcodeScan();
  },
  beforeDestroy() {
    // Make sure to close the connection with the events server
    // when the component is destroyed, or we'll have ghost connections!
    if(msgServer)
      msgServer.close();
  },

  methods: {
    getQrcodeScan: function(){
       //récuperation dans la session
       var sessionSouscription = this.$globalService.getSessionSouscription();
       if(sessionSouscription != null && sessionSouscription.sdkwebScan){
         this.sdkwebScan = sessionSouscription.sdkwebScan;
         
        this.$dialog.warning({
          text: "Scanner le qrcode ci-contre avec votre tablette afin d'uploader les documents",
          title: 'Upload des pièces justificatives',
          persistent: true
        });

            //***************************** PARTIE SSE */
            this.$sse(appService.getBaseUrl()+'/sse/sse_scan.php?idSouscription='+sessionSouscription.souscriptionId, { format: 'json' })
              .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;
        
                //si statut progress ne fais rien 
                sse.subscribe('PROGRESS', () => {
                  this.message = 'TRAITEMENT EN COURS !!!';
                  

                });

                //si statut progress ne fais rien 
                sse.subscribe('FINISH', () => {
                  this.message = "ANALYSE DES DOCUMENTS EN COURS !!!";
                  msgServer.close();
                    //appel de la fonction checkDossier
                    var sessionSouscription = this.$globalService.getSessionSouscription();

                    doccliService.checkDossier(sessionSouscription.doccli_id).then(res => {                       
                      this.showWait = false;
                      if(res){
                        if (res.err !='error') {
                          const data = res.params.data;
                          this.$globalService.setSessionSouscription('resultCheckScan',data);
                          if(data.checkStatus == 'ERROR'){
                            //redirection vers liste erreurs scan
                            this.$router.push({name: 'RecapScanError'});
                          }else if(data.checkStatus == 'WARNING'){
                            //redirection vers liste erreurs scan
                            this.$router.push({name: 'RecapScanWarning'});
                          }else{
                            //redirect vers recap scan
                            if(this.token)
                              this.$router.push({name: 'RecapScanOkForToken'});
                            else
                              this.$router.push({name: 'RecapScanOk'});
                          }
                         
                                    
                        }else{
                          this.$dialog.error({
                            text: "Analyse impossible suite à une erreur technique",
                            title: 'Erreur',
                            persistent: false,
                            actions: {
                              false: 'Fermer'
                            }
                          })
                        
                        }
                      }
                    }).catch(error=>{
                
                          this.loading = false;
                          this.$dialog.notify.error(this.$root.errorMessage, {
                                    position: 'bottom-right',
                                    timeout: 5000
                                  })
                        return error;
                      })
                });

                sse.subscribe('ERROR', () => {
                  this.showWait = false;
                  this.$dialog.error({
                    text: this.$root.errorMessage,
                    title: 'Erreur',
                    persistent: false,
                    actions: {
                      false: 'Fermer'
                    }
                  })
                  msgServer.close();
                });
            })
          .catch(err => {
            
              console.error('Failed to connect to server', err);
              this.$dialog.error({
                text: this.$root.errorMessage,
                title: 'Erreur',
                persistent: false,
                actions: {
                  false: 'Fermer'
                }
              })
          });

        //******************* FIN SSE */
       }else{
        this.$dialog.error({
          text: this.$root.errorMessage,
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
       }
      
    }
  }
}